import { Component, OnInit } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: 'sen-app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent implements OnInit {
  mountingPrice: number = 0;
  public form: FormGroup;
  constructor(public translate: TranslateService, public formGroup: FormBuilder) {
    this.form = formGroup.group({
      mounting: ''

    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

}
